module.exports = __webpack_public_path__ + "static/img/1_9_1.0d180d45.jpg";